import { usePasswordEditorState } from 'hooks/usePasswordEditorState';
import { PasswordFormError } from 'types/state';

export const usePasswordFormError = (): undefined | PasswordFormError => {
  const { formError } = usePasswordEditorState();

  return formError;
};
